var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div ng-if=\"$ctrl.token && $ctrl.payfabricWalletPage\"><iframe width=\"600\" height=\"1000\" ng-src=\"{{$ctrl.payfabricWalletPage}}\"></iframe></div>";
var id1="cart-creditcard-payfabric.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;